import { computed, defineComponent } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import { TransactTypes } from '@/types/transact';
import PaymentOptions from '@/components/transact/PaymentOptions.vue';
import OrderSummary from '@/components/transact/OrderSummary.vue';
import BuyHome from '@/components/transact/Home.vue';
import ListCurrencies from '@/components/currency/ListCurrencies.vue';
import CancelTransaction from '@/components/transact/CancelTransaction.vue';
import NoChannels from '@/components/transact/NoChannels.vue';
export default defineComponent({
    name: 'BuyCryptoView',
    props: {},
    components: {
        BuyHome,
        PaymentOptions,
        OrderSummary,
        ListCurrencies,
        NoChannels,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { currentStep } = storeToRefs(transactionsStore);
        const stepsList = [
            {
                name: TransactTypes.TransactSteps.BUY_1,
                component: BuyHome,
            },
            {
                name: TransactTypes.TransactSteps.BUY_2,
                component: PaymentOptions,
            },
            {
                name: TransactTypes.TransactSteps.BUY_3,
                component: OrderSummary,
            },
            {
                name: TransactTypes.TransactSteps.CURRENCY_COIN_SELECT,
                component: ListCurrencies,
            },
            {
                name: TransactTypes.TransactSteps.CANCEL_TRANSACTION,
                component: CancelTransaction,
            },
            {
                name: TransactTypes.TransactSteps.NO_CHANNELS,
                component: NoChannels,
            },
        ];
        const activeTab = computed(() => stepsList.find(item => item.name === currentStep.value).component);
        return {
            currentStep,
            stepsList,
            activeTab,
        };
    },
});
